import dymoShipping from './labels/shipping'
import dymoReturn from './labels/return'
import dymoProduct from './labels/product'
import dymoEan from './labels/ean'


export default {
	shippingLabel: dymoShipping,
	returnLabel: dymoReturn,
	productLabel: dymoProduct,
	eanLabel: dymoEan,

	createAddressLabelForOrderAddress(address) {
		const shippingLabel = {...this.shippingLabel};
		shippingLabel.setCompany(address.company);
		shippingLabel.setName(address.full_name);
		shippingLabel.setStreet(address.full_address);
		shippingLabel.setPostal(address.zip_code);
		shippingLabel.setCity(address.city);

		if (address.country_code === 'NL') {
			shippingLabel.setCountry('Nederland');
		} else if (address.country_code === 'BE') {
			shippingLabel.setCountry('België');
		}

		return shippingLabel;
	}
}